import React, {PureComponent} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper/index'
// import GetAllFormFields from '../../../components/_utils/formUtils'
import moment from 'moment'
import { Card, Form, Table} from 'antd'
import StudentHeader from '../../../components/studentHeader/index'

import Request from '../../../request'
import {connect} from 'react-redux'
import StudentInfo from '../../../components/StudentInfo'


@Form.create()
class StudentMoveReasons extends PureComponent {
    state = {
        studentId: '',
        count: 0,
    }

    async apiRequest(studentId) {
        if (studentId) {
            let data = await Request.loadStudentMovedReasons(studentId)
            this.setState({activityArr: data.data})
        }
    }
    showDrawer1 = () => {
        this.setState({
            visible1: true
        })
    }
    showDrawer = () => {
        this.setState({
            visible: true
        })
    }
    refreshFxn = () => {
        this.setState({refreshChild: !this.state.refreshChild})
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }
    async componentDidMount() {
        let searchParams = new URLSearchParams(this.props.search)
        let studentId = searchParams.get('id')
        this.setState({studentId: studentId}, async() => {
            this.apiRequest(studentId)
            let {doc} = await Request.getInquiry(studentId)
            this.setState({completeInfo: doc})
        })
    }
    render() {
        const {completeInfo} = this.state

        const columns = [
            {
                title: 'At Level',
                key: 'atLevel',
                dataIndex: 'atLevel',
                width: 150,
            },
            {
                title: 'Reason',
                key: 'moveReason',
                dataIndex: 'moveReason',
                width: 150,
            },
            {
                title: 'Reason Type',
                key: 'moveReasonType',
                dataIndex: 'moveReasonType',
                width: 150,
            },
            {
                title: 'Reason By User',
                key: 'moveReasonUser',
                dataIndex: 'moveReasonUser',
                width: 250,
                render: (val, record) => {
                    return (<div>
                        <div>Name:- {record.user && record.user.name} </div>
                        <div>Email:- {record.user && record.user.email} </div>
                        <div>Mobile:- {record.user && record.user.userMobile} </div>
                        <div>Branch:- {record.user && record.user.branchHead} - {record.user && record.user.branch} </div>
                    </div>)
                }
            },
            {
                title: 'Done By',
                key: 'createdByUser.name',
                dataIndex: 'createdByUser.name',
                width: 150,
                render: (val, record) => {
                    return (<div>{record.createdByUser && record.createdByUser.name} </div>)
                }
            },
            {
                title: 'Date',
                key: 'createdByUser.time',
                dataIndex: 'createdByUser.time',
                width: 150,
                render: (val, record) => {
                    return (<div> {moment(record.createdByUser.time).format('DD-MMM-YYYY hh:mm:A')} </div>)
                }
            }
        ];

        return (
            <PageHeaderWrapper title={'Student Move Reasons'}>

                {
                    completeInfo ? <div style={{marginBottom: 10}}>
                        <StudentHeader
                            info={this.state.studentId}
                            data={this.state.completeInfo}
                            done={() => {
                            }}
                            dispatch={this.props.dispatch}
                        />
                    </div> : null
                }

                {
                    completeInfo ? <Card bordered={true} style={{marginBottom: 10}}>
                        <StudentInfo
                            info={completeInfo}
                        />
                    </Card> : null
                }

                <Card bordered={true}>
                    <Table
                        columns={columns}
                        dataSource={this.state.activityArr}
                        pagination={false} bordered
                    />
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StudentMoveReasons)
